import { BorrowerEntity } from '../../../../../queries/borrowerEntityQueries';

/** True when the entity has an address line to show (a street line, or a complete city, state and zip). */
export const hasEntityAddress = (entity: BorrowerEntity) =>
    !!(entity.street1 || entity.street2 || (entity.city && entity.state && entity.zipCode));
